// extracted by mini-css-extract-plugin
module.exports = {"small":"TimeEditor_small__1lJLI","tiny":"TimeEditor_tiny__3Zngg","mini":"TimeEditor_mini__oRpdi"};